import React, { Component, Fragment } from 'react'

/**
 * Styles
 */
import './PublicTopBar.css'

// Modules
import { Redirect } from 'react-router-dom';
import { message, Menu, Dropdown, Modal, Button, Input } from 'antd';

/**
 * Firebase configs
 */
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';

class PublicTopBar extends Component {

	constructor(props) {
		super(props)

		this.state = {
			loginDialog: false,
			userIsLogged: false,
			email: '',
			pass: '',
			pageToGo: '',
			loginButtonLoading: false,
		}
	}

	componentDidMount = () => {
		/* Verificar se usuário está conectado */
		const auth = getAuth();
		onAuthStateChanged(auth, (user) => {
			if (user) {
				this.setState({
					userIsLogged: true
				});
			}
		});
	}

	/**
	 * Methods to login
	 */
	openLoginDialog = () => {
		this.setState({ loginDialog: true })
	}

	closeLoginDialog = () => {
		this.setState({ loginDialog: false })
	}

	checkIfSubmit = (key) => {
		if (key === 'Enter')
			this.login(this.state.email, this.state.pass)
	}

	login = (email, pass) => {
		if (email && pass) {
			this.setState({ loginButtonLoading: true })

			const auth = getAuth();
			signInWithEmailAndPassword(auth, email, pass)
				.then(() => {
					this.goToPage('home')
				})
				.catch(err => {
					message.error(err.message)
					this.setState({ loginButtonLoading: false })
				})
		} else {
			message.error('E-mail e senha são obrigatórios');
		}
	}

	goToPage = (route) => {
		this.setState({
			pageToGo: route
		})
	}

	render() {
		/* Go to home page */
		if (this.state.pageToGo === 'home') {
			return <Redirect to='/home' />
		}

		const menuForSmallDevices = (
			<Menu style={{ width: '300px', textAlign: 'center' }}>
				<Menu.Item key="0" style={{ height: '60px', lineHeight: '50px' }}>
					<li><a href="/#start" className='black-text'>Início</a></li>
				</Menu.Item>

				<Menu.Item key="1" style={{ height: '60px', lineHeight: '50px' }}>
					<li><a href="/#champs" className='black-text'>Campeonatos</a></li>
				</Menu.Item>

				<Menu.Item key="2" style={{ height: '60px', lineHeight: '50px' }}>
					<li><a href="/#events" className='black-text'>Eventos</a></li>
				</Menu.Item>

				<Menu.Item key="3" style={{ height: '60px', lineHeight: '50px' }}>
					<li><a href="/#photos" className='black-text'>Galeria de fotos</a></li>
				</Menu.Item>

				{this.state.userIsLogged ?
					<Menu.Item key="4" style={{ height: '60px', lineHeight: '50px' }}>
						<li><a href="/home" className='black-text'>Área restrita</a></li>
					</Menu.Item> :
					<Menu.Item key="4" style={{ height: '60px', lineHeight: '50px' }} onClick={() => this.openLoginDialog()}>
						Fazer login
					</Menu.Item>
				}
			</Menu>
		)

		return (
			<Fragment>
				<nav className='black nav-extended' style={{ padding: '0px 10px', position: 'fixed', zIndex: '10', opacity: '0.8' }}>
					<div class="nav-wrapper">
						<a href="/#start" style={{ fontSize: '24px' }} class="brand-logo white-text">Fúria<b>Fight</b></a>
						<div className='publicTopBarSmallScreen'>
							<Dropdown overlay={menuForSmallDevices} trigger={['click']}>
								<div style={{ lineHeight: '60px', height: '60px' }}>
									<i className="material-icons" style={{ lineHeight: '50px' }}>menu</i><br />
								</div>
							</Dropdown>
						</div>
						<ul id="nav-mobile" class="right hide-on-med-and-down">
							<li><a href="/#start" className='white-text'>Início</a></li>
							<li><a href="/#champs" className='white-text'>Campeonatos</a></li>
							<li><a href="/#events" className='white-text'>Eventos</a></li>
							<li><a href="/#photos" className='white-text'>Galeria de fotos</a></li>
							<li>
								{
									this.state.userIsLogged ?
										<a href="/home" className='white-text'>Área restrita</a> :
										<Button
											type='primary'
											onClick={() => this.openLoginDialog()}
										>Fazer Login</Button>
								}
							</li>
						</ul>
					</div>
				</nav>

				<ul class="sidenav" id="mobile-demo">
					<li><a href="sass.html">Sass</a></li>
					<li><a href="badges.html">Components</a></li>
					<li><a href="collapsible.html">JavaScript</a></li>
				</ul>

				<Modal
					title='Login'
					visible={this.state.loginDialog}
					width={400}
					onCancel={this.closeLoginDialog}
					footer={[
						<Button
							style={{ width: '100%' }}
							type='primary'
							onClick={() => this.login(this.state.email, this.state.pass)}
							onKeyUp={e => this.checkIfSubmit(e.key)}
							loading={this.state.loginButtonLoading}
						>
							Entrar
						</Button>
					]}
				>
					<Input
						placeholder="Email"
						className='sharedInput browser-default'
						style={{ marginBottom: '20px' }}
						onChange={input => this.setState({ email: input.target.value })}
					/>

					<Input
						placeholder="Senha"
						type='password'
						className='sharedInput browser-default'
						onChange={input => this.setState({ pass: input.target.value })}
						onKeyUp={e => this.checkIfSubmit(e.key)}
					/>

				</Modal>
			</Fragment>
		)
	}

}

export default PublicTopBar